import React from 'react';
import ReactDOM from 'react-dom';
import pic from '../shared/Pic';

class NumPic extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default pic(NumPic, 'num');


// WEBPACK FOOTER //
// ./src/components/sections/num/NumPic.js